module.exports = __webpack_public_path__ + "static/media/riverClean.78aec714.png";